module.exports = __webpack_public_path__ + "img/user-switaly.a0f21f7b.png";